/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import Snackbar from 'components/Snackbar';
import CookieBanner from '../../components/CookieBanner';
import actions from 'redux/actions';
// import { getIsAuthenticated } from 'redux/reducers/auth';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import { getTracksDownloadUrl } from 'redux/reducers/app';
import { getWorklists } from 'redux/reducers/worklists';
import { getSessionUsageId, getUsages } from 'redux/reducers/usages';
import type { Fetchable, ReduxState, SimplifiedUsage, SimplifiedWorklist } from 'types';
// import keys from 'config/keys';
import Header from 'screens/Header';
import Footer from 'screens/Footer';
import LoginScreen from 'screens/Login';
import Usages from 'screens/Usages';
import Productions from 'screens/Productions';
import OnDemandRequests from 'screens/OnDemandRequests';
import TrackSearch from 'screens/TrackSearch';
import MediaSearch from 'screens/MediaSearch';
import Worklists from 'screens/Worklists';
import Smartlists from 'screens/Smartlists';
import SmartlistDetail from 'screens/Smartlist';
import Featured from 'screens/Featured';
import FeaturedMedia from 'screens/FeaturedMedia';
import Media from 'screens/Media';
import Cart from 'screens/Cart';
import Purchases from 'screens/Purchases';

import domUtils from 'utils/dom';

import styles from './styles.module.scss';

import { get } from 'lodash';
import { withKeycloak } from '@react-keycloak/web';
import * as Keycloak from 'keycloak-js';

const mapStateToProps = (state: ReduxState) => {
  const usages = get(getUsages(state), 'data', []);
  const sessionUsageId = getSessionUsageId(state);
  const sessionUsage = sessionUsageId.data && usages.find(_ => _.id === sessionUsageId.data);
  return {
    worklists: getWorklists(state),
    sessionUsageId,
    sessionUsage,
    tracksDownloadUrl: getTracksDownloadUrl(state),
    isSnackbarVisible: state.app.isSnackbarVisible,
    snackbarMessage: state.app.snackbarMessage,
    snackbarIsError: state.app.snackbarIsError,
    snackbarIsSticky: state.app.snackbarIsSticky,
  };
};

type Props = {
  isAppReady: boolean,
  isSnackbarVisible: boolean,
  snackbarMessage: string,
  snackbarIsError: boolean,
  snackbarIsSticky: boolean,
  worklists: Fetchable<SimplifiedWorklist[]>,
  sessionUsageId: Fetchable<number | void>,
  sessionUsage?: SimplifiedUsage,
  tracksDownloadUrl?: string,
  fetchWorklistList: typeof actions.fetchWorklistList,
  fetchCategories: typeof actions.fetchCategories,
  getSessionUsageId: typeof actions.getSessionUsageId,
  resetTracksDownloadUrl: typeof actions.resetTracksDownloadUrl,
  hideSnackbar: typeof actions.hideSnackbar,
  setSessionUsageId: typeof actions.setSessionUsageId,
  router: Object,
  children?: React.Node,
  keycloak: Keycloak,
  keycloakInitialized: boolean,
};

class App extends React.PureComponent<Props, void> {
  componentDidUpdate(prevProps) {
    const { tracksDownloadUrl, resetTracksDownloadUrl, keycloak, keycloakInitialized } = this.props;
    if (tracksDownloadUrl) {
      domUtils.browserDownload(tracksDownloadUrl);
      resetTracksDownloadUrl();
    }
    const previouslyAuthenticated =
      prevProps.keycloakInitialized && prevProps.keycloak.authenticated;
    const currentlyAuthenticated = keycloakInitialized && keycloak.authenticated;
    if (!previouslyAuthenticated && currentlyAuthenticated) {
      if (!this.props.worklists.data && !this.props.worklists.fetching) {
        this.props.fetchWorklistList();
      }
      if (!this.props.sessionUsageId.data && !this.props.sessionUsageId.fetching) {
        // TODO fetching non � realmente applicabile
        this.props.getSessionUsageId();
      } else if (this.props.sessionUsageId.data && !this.props.sessionUsage) {
        this.props.setSessionUsageId();
      }
      this.props.fetchCategories();
    }
  }

  render() {
    const {
      isSnackbarVisible,
      snackbarMessage,
      snackbarIsError,
      snackbarIsSticky,
      hideSnackbar,
      keycloak,
      keycloakInitialized,
    } = this.props;

    if (!keycloakInitialized) {
      // ===========================
      //   App in caricamento
      // ===========================
      return <div className={styles.container} />;
    } else if (!keycloak.authenticated) {
      // ===========================
      //   Utente non autenticato
      // ===========================
      return (
        <React.Fragment>
          <LoginScreen />
          <Snackbar
            visible={isSnackbarVisible}
            text={snackbarMessage}
            onHide={hideSnackbar}
            isError={snackbarIsError}
            isSticky={snackbarIsSticky}
          />
          <CookieBanner />
        </React.Fragment>
      );
    } else {
      // ===========================
      //   Utente autenticato
      // ===========================
      return (
        <HashRouter>
          <div className={styles.container}>
            <Header className={styles.header} />
            <main className={styles.mainContent}>
              <Switch>
                <Redirect exact from={'/'} to={'/news'} />
                <Route
                  exact
                  path={'/news'}
                  render={props => <MediaSearch {...props} key="news" />}
                />
                <Route path={'/usages/:usageId'} component={Usages} />
                <Route path={'/usages'} component={Usages} />
                <Route path={'/productions/:productionId'} component={Productions} />
                <Route path={'/productions'} component={Productions} />
                <Route path={'/worklists/:worklistId'} component={Worklists} />
                <Route path={'/worklists'} component={Worklists} />
                <Route exact path={'/smartlists'} component={Smartlists} />
                <Route exact path={'/smartlists/:smartlistId'} component={SmartlistDetail} />
                <Route exact path={'/featured'} component={Featured} />
                <Route exact path={'/featured/:featuredId'} component={FeaturedMedia} />
                <Route exact path={'/ondemand'} component={OnDemandRequests} />
                <Route exact path={'/tracks/search'} component={TrackSearch} />
                <Route
                  exact
                  path={'/medias/search'}
                  render={props => <MediaSearch {...props} key="mediaSearch" />}
                />
                <Route exact path={'/medias/:mediaId'} component={Media} />
                <Route exact path={'/cart'} component={Cart} />
                <Route exact path={'/purchases'} component={Purchases} />
              </Switch>
            </main>
            <Footer className={styles.footer} />
            <Snackbar
              visible={isSnackbarVisible}
              text={snackbarMessage}
              onHide={hideSnackbar}
              isError={snackbarIsError}
              isSticky={snackbarIsSticky}
            />
            {/* {keys.DISPLAY_VERSION && (
              <div className={styles.version}>{`V. ${keys.DISPLAY_VERSION}`}</div>
            )} */}
            <CookieBanner />
          </div>
        </HashRouter>
      );
    }
  }
}

export default withKeycloak(connect(mapStateToProps, actions)(App));
